import * as T from "three";

const ray = new T.Raycaster();
const direction = new T.Vector3();
const right = new T.Vector3();
const up = new T.Vector3();
const origin = new T.Vector3();
const vertical = new T.Vector3(0, 1, 0);

// Sample the camera's volume, including the corners missed by a centre ray.
export function clearCameraBoom(
  focus: T.Vector3,
  desired: T.Vector3,
  blockers: T.Object3D[],
  radius = 0.45,
) {
  direction.subVectors(desired, focus);
  const length = direction.length();
  if (length < 0.001) return desired;
  direction.divideScalar(length);
  right.crossVectors(direction, vertical).normalize();
  if (right.lengthSq() < 0.001) right.set(1, 0, 0);
  up.crossVectors(right, direction).normalize();
  ray.far = length + radius;
  let clearance = length;
  for (const x of [-1, 0, 1]) {
    for (const y of [-1, 0, 1]) {
      origin.copy(focus).addScaledVector(right, x * radius).addScaledVector(up, y * radius);
      ray.set(origin, direction);
      const hit = ray.intersectObjects(blockers, false)[0];
      if (hit) clearance = Math.min(clearance, Math.max(0.1, hit.distance - radius));
    }
  }
  return desired.copy(focus).addScaledVector(direction, clearance);
}
